import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import AssessmentDesc from "../../../templates/teacher/AssessmentDesc";
import { assessmentPath, Context } from "../../../teacherStore";

export default () => {
  const history = useHistory();
  const { state } = useContext(Context);

  const handleDirectToAssessmentList = React.useCallback(() => {
    history.push(assessmentPath);
  }, [history]);

  return (
    <AssessmentDesc
      onDirectToAssessment={handleDirectToAssessmentList}
      isManager={state.is_manager}
      onlyAssessment={state.only_assessment}
    />
  );
};
